import { FC, useEffect, useRef } from 'react';
import { React360Viewer } from 'react-360-product-viewer';
import Typography from '@components/typography';
import External360Icon from '@components/external360icon';

import { useAppDispatch, useAppSelector } from '@hooks/statehooks';
import { useDeviceDetect } from '@hooks/usedevicedetect';
import { setVehicleExterior } from '@store/reducers/vehicleexterior';
import Loader from '@components/loader/loader';

interface Props {
  modelCode?: number;
  doors?: number;
  train?: string;
  year?: string;
  trim?: string;
}

const Exterior: FC<Props> = ({
  modelCode,
  doors,
  train,
  year,
  trim,
}: Props) => {
  const dispatch = useAppDispatch();
  const { loading, imageList, baseImageUrl, fileExtension, filenamePrefix } =
    useAppSelector((state) => state.vehicleExterior);
  const hasFetchedData = useRef(false);
  const { isMobile } = useDeviceDetect();
  const message = isMobile
    ? 'The images on here are just to give you an idea. Not your actual car.'
    : 'The images on here are just to give you an idea, not your actual car. Please use your mouse to interact with the car.';
  const noExteriorView = 'No exterior view is available';

  useEffect(() => {
    if (!hasFetchedData.current && modelCode) {
      dispatch(setVehicleExterior({ modelCode, doors, trim, train, year }));
    }
  }, []);

  return (
    <div className="image-gallery-container__content-view360-exterior">
      {loading ? (
        <Loader />
      ) : (
        <>
          {(!modelCode || imageList.length === 0) && (
            <Typography size="rg" variant="body1">
              {noExteriorView}
            </Typography>
          )}
          {modelCode && imageList.length > 0 && (
            <>
              <Typography size="rg" variant="body1">
                {message}
              </Typography>
              <div className="image-gallery-container__content-view360-exterior-viewer">
                <React360Viewer
                  imagesBaseUrl={baseImageUrl}
                  imagesCount={imageList.length}
                  imagesFiletype={fileExtension}
                  mouseDragSpeed={20}
                  imageFilenamePrefix={filenamePrefix}
                  width={isMobile ? 359 : 492}
                  height={isMobile ? 240 : 328}
                  autoplay={true}
                  reverse={true}
                />
                <External360Icon />
              </div>
            </>
          )}
        </>
      )}
    </div>
  );
};

export default Exterior;
